<template lang="pug">
  .traction__map-info
    .traction__map-info__header(v-if="checkingItem")
      .traction__map-info__user
        .traction__map-info__text
          | {{data.name}}
        .traction__map-info__text
          | {{data.lastname}}
        .traction__map-info__city
          | ( {{data.city}} )
        .msg-tariff(v-if="streamData")
          | {{streamData.name}}
        .msg-stream(v-if="tariffData")
          | {{tariffData.name}}
      .msg__bisness
        .traction__map-info__niche(v-if="data.niche")
          | Ниша:
        .traction__map-info__text(v-if="data.niche")
          | {{data.niche}}

      .traction__map-connect
        Phone.traction__map-info__text(v-if="data.phone" :value="data.phone")

        .traction__map-links
          Icon.traction__map-svg(
            v-if="data.siteLink"
            icon="siteLink"
            @click="moveTo"
          )
          InlineSocials(
            :vk="data.vkLink"
            :fb="data.fbLink"
            :insta="data.instaLink"
          )
    .traction__map-info__body
      .flex
        .traction__map-text
          | Трекер:
        .traction__map-text.traction__map-text__black(v-if="tracker")
          | {{ tracker.name}}  {{ tracker.lastname}}
        .traction__map-text.traction__map-text__black(v-else)
          | Не указан
      .flex
        .traction__map-text
          | Менеджер:
        .traction__map-text.traction__map-text__black(v-if="manager")
          | {{ manager.name}} {{ manager.lastname}}
        .traction__map-text.traction__map-text__black(v-else)
          | Не указан
      .flex
        .traction__map-text
          | Оборот за прошлый год:
        .traction__map-text.traction__map-text__black
          | {{ profitPerYear}}
      .flex
        .traction__map-text
          | Чистая прибыль за прошлый год:
        .traction__map-text.traction__map-text__black
          | {{ profitPerLastYear}}
      .msg-createdAt
        p.msg-text
          | {{ info.createdAt}}
</template>
<script>
import { mapState } from 'vuex';
import InlineSocials from '@/components/InlineSocials';
import Select from './Select';

export default {
  components: { InlineSocials, Select },
  props: ['data', 'info'],
  computed: {
    ...mapState('msg', {
      tariffs: s => s.data.tariffs,
      streams: s => s.data.streams,
      users: s => s.data.users
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.userTeamModuleAdmin,
      userId: s => s.data.user.id
    }),
    manager() {
      return this.users.find(el => el.id == this.info.managerId);
    },
    tracker() {
      return this.users.find(el => el.id == this.info.trackerId);
    },
    isAdmin() {
      return this.$permissionsPointUpdate == 2;
    },
    profitPerYear() {
      if (
        !this.data.profitPerYear ||
        this.data.profitPerYear.length === 0 ||
        typeof this.data.profitPerYear === 'undefined'
      ) {
        return 0;
      }
      return this.addSpaceInNumber(this.data.profitPerYear);
    },
    profitPerLastYear() {
      if (
        !this.data.profitPerLastYear ||
        this.data.profitPerLastYear.length === 0 ||
        typeof this.data.profitPerLastYear === 'undefined'
      ) {
        return 0;
      }
      return this.addSpaceInNumber(this.data.profitPerLastYear);
    },
    checkingItem() {
      return Object.keys(this.data).length > 0;
    },
    streamData() {
      return this.streams.find(el => el.id == this.info.streamId);
    },
    tariffData() {
      return this.tariffs.find(el => el.id == this.info.tariffId);
    }
  },
  methods: {
    addSpaceInNumber(data) {
      let str = '';
      let value = data;
      value = value.toString();

      if (value.split(' ').length > 1) {
        value = value.split(' ').join('');
      }

      value = value
        .replace(/[^0-9]+/g)
        .split('')
        .reverse();

      value.forEach((el, idx) => {
        str += el;
        if ((idx + 1) % 3 === 0) {
          str += ' ';
        }
      });

      return str.split('').reverse().join('');
    },
    moveTo() {
      if (/^(http|https):/.test(this.data.siteLink)) {
        window.open(this.data.siteLink, '_blank');
      } else {
        window.open('https://' + this.data.siteLink, '_blank');
      }
    }
  }
};
</script>
